import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UserActivityEnum } from "../models/UserActivityEnum";
import { DynamicMessageTypeEnum } from "./lms-shared/models/DynamicMessageTypeEnum";
import DynamicMessage from "./lms-shared/UI/Popups/DynamicMessage/DynamicMessage";


const Permissions = ({ children, activityType, cancelAction = false }) => {
    // check permission if cancelAction show message else return null

    const permissions = useSelector(state => state.auth.user.permissions);
    const [message, setMessage] = useState();
    const [permission, setPermission] = useState(false);
    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        if (permissions)
            if (!activityType || permissions[activityType] || activityType === UserActivityEnum.Any && Object.values(permissions).some(p => p === true)) {
                setPermission(true)
            }
            else {
                setMessage(true)
            }
    }, [permissions, activityType])

    return <>
        {permission ?
            children : cancelAction && message && <DynamicMessage type={DynamicMessageTypeEnum.NoEnter} content={texts.errorNoPermissionActivity} title={texts.Warn} />
        }
    </>

}
export default Permissions